import { axios, Response } from '../../index'

export type SendEmailCodeRequest = {
  emailToRecovery: string
}

const sendEmailCode = (request: SendEmailCodeRequest): Response<null> => {
  return axios.put(`/v1/users/passwords`, request)
}

export default sendEmailCode
